import { DoorAssessment, IDoorAssessment } from "../../../entities-generated/common/door-assessment";
import { IDoorHandingOption } from "../../../entities-generated/common/door-handing-option";
import { IDoorSizeOption } from "../../../entities-generated/common/door-size-option";
import { IDoorTypeOption } from "../../../entities-generated/common/door-type-option";
import { IStandardLabor } from "../../../entities-generated/common/standard-labor";
import { IStandardMaterial } from "../../../entities-generated/common/standard-material";

export interface IAssessmentDoorEditingModel extends IDoorAssessment {
  doorTypeOptions: IDoorTypeOption[];
  doorSizeOptions: IDoorSizeOption[];
  doorHandingOptions: IDoorHandingOption[];
  standardLaborOptions: IStandardLabor[];
  standardMaterialOptions: IStandardMaterial[];
}

export class AssessmentDoorEditingModel extends DoorAssessment implements IAssessmentDoorEditingModel {
    constructor(
      assessment: IDoorAssessment = new DoorAssessment(),
      public doorTypeOptions: IDoorTypeOption[] = [],
      public doorSizeOptions: IDoorSizeOption[] = [],
      public doorHandingOptions: IDoorHandingOption[] = [],
      public standardLaborOptions: IStandardLabor[] = [],
      public standardMaterialOptions: IStandardMaterial[] = [],
    )
    {
      super();
      this.id = assessment.id;
      this.doorType = assessment.doorType;
      this.handing = assessment.handing;
      this.size = assessment.size;
      this.cutdownRequired = assessment.cutdownRequired;
      this.alias = assessment.alias;
      this.photoIds = assessment.photoIds;
      this.laborScope = assessment.laborScope;
      this.materials = assessment.materials;
      this.existingDoorPresent = assessment.existingDoorPresent;
    }
}